import { ConfigEditor } from './ConfigEditor';
import { buildInstanceCdnUrl } from '@/lib/utils/cdn';

interface ConfigEditorModalProps {
  instanceId: string;
  isPreview?: boolean;
  onClose: () => void;
}

/**
 * Modal wrapper for ConfigEditor
 * Use this when you want to open the editor as a modal by just passing instanceId
 */
export function ConfigEditorModal({ instanceId, isPreview = false, onClose }: ConfigEditorModalProps) {
  const previewUrl = buildInstanceCdnUrl(instanceId);

  return (
    <ConfigEditor instanceId={instanceId} previewUrl={previewUrl} isPreview={isPreview} onClose={onClose} />
  );
}
